import React from "react";
import { User } from "../../types";

interface UserAvatarProps {
  user: Pick<User, "first_name" | "last_name" | "avatar_url">;
  /** px size — drives both width/height and font size */
  size?: number;
  className?: string;
}

/**
 * Shows the user's avatar image if available, otherwise falls back to
 * two-letter initials. Drop this anywhere initials were rendered inline.
 */
const UserAvatar: React.FC<UserAvatarProps> = ({
  user,
  size = 28,
  className = "",
}) => {
  const [imgError, setImgError] = React.useState(false);
  const initials = `${user.first_name?.[0] ?? ""}${user.last_name?.[0] ?? ""}`;
  const showImage = !!user.avatar_url && !imgError;

  const style: React.CSSProperties = {
    width: size,
    height: size,
    minWidth: size,
    fontSize: Math.max(9, Math.round(size * 0.36)),
  };

  if (showImage) {
    return (
      <img
        src={user.avatar_url!}
        alt={initials}
        onError={() => setImgError(true)}
        style={style}
        className={`rounded-full object-cover border border-primary/30 shrink-0 ${className}`}
      />
    );
  }

  return (
    <div
      style={style}
      className={`rounded-full bg-primary/20 border border-primary/30 flex items-center justify-center shrink-0 ${className}`}
    >
      <span className="text-primary font-bold leading-none">{initials}</span>
    </div>
  );
};

export default UserAvatar;
